import axios from "axios";

// Use a RELATIVE `/api` base so the app works on ANY domain
// (preview `*.preview.emergentagent.com` and production `passionverre.com`).
// Kubernetes ingress automatically routes `/api/*` to the backend on the same host.
// `REACT_APP_BACKEND_URL` is intentionally ignored at runtime to avoid
// baking a preview URL into the production build.
export const API = "/api";

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_8292f8d7-2a53-4e77-813a-5bfc0b0babfc/artifacts/hr1yr617_PASSION%20VERRE%20Logo%20gravure%20et%20d%C3%A9coupe%20lyon.png";

export const CATEGORIES = [
  { slug: "all", label: "Toutes" },
  { slug: "verres", label: "Verres" },
  { slug: "tasses-mugs", label: "Tasses & Mugs" },
  { slug: "lots-coffrets", label: "Lots & Coffrets" },
  { slug: "vases", label: "Vases" },
  { slug: "couteaux-planches", label: "Couteaux" },
  { slug: "bois", label: "Bois" },
  { slug: "metaux", label: "Métaux" },
  { slug: "decoration", label: "Décoration" },
  { slug: "sur-mesure", label: "Sur-mesure" },
];

export const BLOG_CATEGORIES = [
  { slug: "all", label: "Tous", color: "#9A8640" },
  { slug: "gravure", label: "Gravure", color: "#9A8640" },
  { slug: "cadeaux", label: "Cadeaux personnalisés", color: "#B87333" },
  { slug: "mariage", label: "Mariage", color: "#A8324E" },
  { slug: "decoration", label: "Décoration", color: "#6B8E5A" },
  { slug: "professionnels", label: "Professionnels", color: "#3D5B7A" },
  { slug: "tutoriels", label: "Tutoriels", color: "#7A5C3D" },
];

export const blogCategoryColor = (slug) =>
  BLOG_CATEGORIES.find((c) => c.slug === slug)?.color || "#9A8640";

export const PROJECT_TYPES = [
  "Mariage",
  "Cadeau personnalisé",
  "Cadeau d'entreprise",
  "Trophée / récompense",
  "Plaque / enseigne",
  "Décoration",
  "Autre / sur-mesure",
];
